// @ts-check

/**
 * Call callback every ms until it returns true
 *
 * @param {() => Promise<boolean>} callback
 * @param {object} options
 * @param {AbortSignal} [options.signal]
 * @param {number} [options.ms]
 */
export default function callUntil(callback, { signal, ms = 2000 }) {
  if (signal?.aborted) {
      return Promise.reject(new DOMException('Aborted', 'AbortError'));
  }

  async function until(resolve) {
    if (signal?.aborted) {
      return;
    }

    if (await callback()) {
      resolve();
    } else {
      setTimeout(() => until(resolve), ms);
    }
  }

  return new Promise((resolve, reject) => {
    signal.addEventListener('abort', () => reject(new DOMException('Aborted', 'AbortError')));
    until(resolve);
  });
}
